<!--安装订单页-->
<template>
    <div class="sales">
        <div style="padding: 10px 0px 0px 0px">
            <van-icon name="arrow-left" size="20px" @click="onback"/>
        </div>
        <van-cell-group>
            <van-field
                    readonly
                    clickable
                    required
                    :value="money"
                    @click="show = true"
                    label="金额"
                    placeholder="应收总金额"
            />
            <!--       移动端点击bug未清楚     -->
            <!--                    @touchstart.native.stop="show = true"-->

            <van-number-keyboard
                    v-model="money"
                    :show="show"
                    transition
                    extra-key="."
                    :maxlength="10"
                    @blur="show = false"
            />

            <van-field
                    readonly
                    required
                    clickable
                    label="日期"
                    v-model="overtime"
                    placeholder="服务到期时间"
                    @click="showPicker = true"
            />

            <van-popup v-model="showPicker" position="bottom">
                <van-datetime-picker
                        v-model="currentDate"
                        :currentDate="currentDate"
                        type="date"
                        :min-date="minDate"
                        @cancel="onCancel"
                        @confirm="onConfirm(currentDate)"
                />
            </van-popup>
            <van-field
                    v-model="salesmanname"
                    readonly
                    required
                    clearable
                    label="业务员"
                    placeholder="跟进业务员"
            />
            <keyboard v-model="registrationNum" title="改键盘">
                <van-field
                        v-model="registrationNum"
                        required
                        readonly
                        clearable
                        label="车牌号"
                        placeholder="车牌号"
                />
            </keyboard>
            <!--            <letter-keyboard  v-model="vin" >-->
            <van-field
                    type="textarea"
                    v-model="vin"
                    required
                    clearable
                    label="车架号"
                    placeholder="车架号"
            />
            <!--            </letter-keyboard>-->

            <van-field
                    v-model="engineNum"
                    clearable
                    label="发动机号"
                    placeholder="发动机号"
            />
            <van-dropdown-menu>
                <van-dropdown-item v-model="value1" :options="option1" @change="changeMenu"/>
                <van-dropdown-item v-model="value2" :options="option2" @change="changeMenu2"/>
            </van-dropdown-menu>
            <van-dropdown-menu>
                <van-dropdown-item v-model="value3" :options="option3" @change="changeMenu3"/>
                <van-dropdown-item v-model="value4" :options="option4" @change="changeMenu4"/>
                <van-dropdown-item v-model="value5" :options="option5" @change="changeMenu5"/>
            </van-dropdown-menu>
            <AutoComplete
                    @on-search="changedata3"
                    clearable
                    v-model="clientInfoIdname"
                    :data="data3"
                    :filter-method="filterMethod"
                    placeholder="客户信息"
                    size="small"
                    style="width:180px;padding: 5px">
            </AutoComplete>
            <van-button size="mini" style="padding: 0px 5px 0px 5px" type="info" @click="addclientInfoId">添加客户信息
            </van-button>
            <br/>

            <AutoComplete
                    @on-search="changedata4"
                    clearable
                    v-model="vehicleOwnerInfoIdname"
                    :data="data4"
                    :filter-method="filterMethod"
                    placeholder="车辆所有人信息"
                    size="small"
                    style="width:180px;padding: 5px">
            </AutoComplete>
            <van-button size="mini" style="padding: 0px 5px 0px 5px" type="info" @click="addvehicleOwnerInfoId">
                添加车辆所有人信息
            </van-button>

            <AutoComplete
                    @on-search="changedata5"
                    clearable
                    v-model="vehicleInfoGroup"
                    :data="data5"
                    :filter-method="filterMethod"
                    placeholder="车辆分组"
                    size="small"
                    style="width:180px;padding: 5px">
            </AutoComplete>

            <AutoComplete
                    @on-search="changedata6"
                    clearable
                    v-model="salesChannel"
                    :data="data6"
                    :filter-method="filterMethod"
                    placeholder="销售渠道"
                    size="small"
                    style="width:180px;padding: 5px">
            </AutoComplete>

            <van-cell-group>
                <van-field
                        v-model="remark"
                        rows="2"
                        autosize
                        label="备注"
                        type="textarea"
                        maxlength="250"
                        placeholder="请输入备注"
                />
            </van-cell-group>
        </van-cell-group>
        <br/>
        <div class="_button">
            <van-button size="large" style="width: 90%;" type="info" :disabled="disabled" @click="ok">确定创建</van-button>
        </div>
        <br>
        <div class="_button">
            <van-button size="large" style="width: 90%" type="warning" to="../resalesman">取消</van-button>
        </div>

        <Modal
                v-model="modal2"
                title="增加客户信息"
                @on-ok="ok2"
                @on-cancel="cancel2">
            <Input v-model="name" size="small" clearable placeholder="客户名称" style="width: 100%;padding: 5px"><span
                    slot="prepend">客户名称:</span></Input>
            <Input v-model="phoneNum" size="small" clearable placeholder="客户手机号" style="width: 100%;padding: 5px"><span
                    slot="prepend">客户手机号:</span></Input>
            <Input v-model="address" size="small" clearable placeholder="客户地址" style="width: 100%;padding: 5px"><span
                    slot="prepend">客户地址:</span></Input>
        </Modal>

        <Modal
                v-model="modal3"
                title="增加客户信息"
                @on-ok="ok3"
                @on-cancel="cancel3">
            <Input v-model="vehicleOwnerInfoname" size="small" clearable placeholder="车辆所有人名称"
                   style="width: 100%;padding: 5px"><span
                    slot="prepend">车辆所有人名称:</span></Input>
            <Input v-model="vehicleOwnerInfophoneNum" size="small" clearable placeholder="车辆所有人手机号"
                   style="width: 100%;padding: 5px"><span
                    slot="prepend">车辆所有人手机号:</span></Input>
            <Input v-model="vehicleOwnerInfoaddress" size="small" clearable placeholder="车辆所有人地址"
                   style="width: 100%;padding: 5px"><span
                    slot="prepend">车辆所有人地址:</span></Input>
            <Input v-model="vehicleOwnerInforemark" size="small" clearable placeholder="车辆所有人备注"
                   style="width: 100%;padding: 5px"><span
                    slot="prepend">车辆所有人备注:</span></Input>
        </Modal>

    </div>
</template>

<script>

    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        NumberKeyboard,
        Toast,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(DropdownItem).use(Sticky)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse)
        .use(NumberKeyboard).use(CollapseItem).use(DatetimePicker).use(Icon).use(Toast);


    export default {
        name: "resalesman",
        data() {
            return {
                currentDate: new Date(),
                showPicker: false,
                minDate: new Date(),

                checked: false,
                disabled: false,

                licenseNumber: '',

                value: '',
                installlist: [],
                list: [],
                list2: [],
                list3: [],
                list4: [],
                list5: [],
                list6: [],//销售渠道
                modal1: false,
                modal2: false,
                modal3: false,
                money: '',//应收总金额
                show: false,
                overtime: '',//服务到期时间
                salesmanID: '',//跟进业务员id
                salesmanname: '',//跟进业务员名称
                businessType: '',//业务类型
                businessTypename: '业务类型',//业务类型名称
                qghyptOption: '',//上传货运平台选项
                qghyptOptionname: '全国货运平台',//上传货运平台选项名称
                billType: '',//开票类型
                billTypename: '开票类型',//开票类型名称
                remark: '',//备注
                clientInfoIdname: '',//客户信息名称
                clientInfoId: '',//客户信息
                registrationNum: null,//车牌号
                registrationColor: '',//车牌颜色
                registrationColorname: '车牌颜色',//车牌颜色名称
                vin: null,//车架号
                attention: false,//重点关注车辆
                vehicleOwnerInfoIdname: '',//车辆所有人信息名称
                vehicleOwnerInfoId: '',//车辆所有人信息
                engineNum: '',//发动机号
                vehicleInfoGroupId: '',//预绑定车辆分组id
                vehicleInfoGroup: '',//预绑定车辆分组
                salesChannelId: '',//销售渠道id
                salesChannel: '',//销售渠道


                data3: [],
                data4: [],
                data5: [],
                data6: [],//销售渠道

                activeName: [],

                value1: 0,
                option1: [
                    {text: '业务类型', value: 0},
                    {text: '新装', value: 1},
                    {text: '接入', value: 2},
                ],
                value2: 0,
                option2: [
                    {text: '全国货运平台', value: 0},
                    {text: '不需上传', value: 1},
                    {text: '新车上传', value: 2},
                    {text: '旧车转网', value: 3},
                ],
                value3: 0,
                option3: [
                    {text: '开票类型', value: 0},
                    {text: '增值税发票', value: 1},
                    {text: '增值税专用发票', value: 2},
                    {text: '增值税普通发票', value: 3},
                ],
                value4: 0,
                option4: [
                    {text: '车辆颜色', value: 0},
                    {text: '蓝色', value: 1},
                    {text: '黄色', value: 2},
                    {text: '黑色', value: 3},
                    {text: '白色', value: 4},
                ],
                value5: 0,
                option5: [
                    {text: '不是重点关注', value: 0},
                    {text: '是重点关注', value: 1},
                ],

                readonly: true,

                name: '',//客户名称
                phoneNum: '',//客户手机号
                address: '',//客户地址

                vehicleOwnerInfoname: '',//车辆所有人名称
                vehicleOwnerInfophoneNum: '',//车辆所有人手机号
                vehicleOwnerInfoaddress: '',//车辆所有人地址
                vehicleOwnerInforemark: '',//车辆所有人备注


                textname: '',
            }
        },
        methods: {
            //返回上一页
            onback() {
                this.$router.push({
                    name: 'resalesman'
                })
            },
            //日期选择开关
            onCancel() {
                this.showPicker = false
            },
            onConfirm(e) {
// console.log(e)
                this.overtime = e.Format('yyyy-MM-dd')
                console.log(this.overtime)
                this.showPicker = false
            },
            // onclose(){
            //     window.close()
            // },


            //更改业务类型
            changeMenu(name) {
                if (name === 0) {
                    this.businessType = 0
                } else if (name === 1) {
                    this.businessType = 1
                    // this.businessTypename = '新装'
                } else if (name === 2) {
                    this.businessType = 2
                    // this.businessTypename = '接入'
                }
            },
            //更改上传货运平台选项
            changeMenu2(name) {
                if (name === 0) {
                    this.qghyptOption = -1
                } else if (name === 1) {
                    this.qghyptOption = 0
                    // this.qghyptOptionname = '不需上传'
                } else if (name === 2) {
                    this.qghyptOption = 1
                    // this.qghyptOptionname = '新车上传'
                } else if (name === 3) {
                    this.qghyptOption = 2
                    // this.qghyptOptionname = '旧车转网'
                }
            },
            //更改开票类型
            changeMenu3(name) {
                if (name === 0) {
                    this.billType = 0
                } else if (name === 1) {
                    this.billType = 1
                    // this.billTypename = '增值税发票'
                } else if (name === 2) {
                    this.billType = 2
                    // this.billTypename = '增值税专用发票'
                } else if (name === 3) {
                    this.billType = 3
                    // this.billTypename = '增值税普通发票'
                }
            },
            //更改车牌颜色
            changeMenu4(name) {
                if (name === 0) {
                    this.registrationColor = 0
                } else if (name === 1) {
                    this.registrationColor = 1
                    // this.registrationColorname = '蓝色'
                } else if (name === 2) {
                    this.registrationColor = 2
                    // this.registrationColorname = '黄色'
                } else if (name === 3) {
                    this.registrationColor = 3
                    // this.registrationColorname = '黑色'
                } else if (name === 4) {
                    this.registrationColor = 4
                    // this.registrationColorname = '白色'
                }
            },
            //重点关注
            changeMenu5(name) {
                if (name === 0) {
                    this.attention = false
                } else if (name === 1) {
                    this.attention = true
                }
            },

            //客户信息模糊查询
            changedata3(e) {
                console.log(e)
                this.data3 = []
                //获取客户列表
                store.dispatch('ClientInfoServ_SearchByName'

                    , {
                        params: {
                            name: this.clientInfoIdname
                        },
                        urlparams: null
                    }).then((res) => {
                    console.log(res)
                    this.list = res.data
                    // this.list3 = []
                    for (let i = 0; i < res.data.length; i++) {
                        this.list3.push(res.data[i])
                        this.data3.push(res.data[i].name)
                    }
                })
                    .catch((err) => {
                        console.log(err)
                    })

                // this.change()


            },
            change() {
                // eslint-disable-next-line eqeqeq
                this.data3 = []
                if (!this.clientInfoIdname || this.clientInfoIdname === '') {
                    // this.data3.splice(0)
                } else {
                    // this.data3.splice(0)

                    let result = []
                    for (let i = 0; i < this.list.length; i++) {
                        let str = this.list[i].name
                        if (str.toUpperCase().indexOf(this.clientInfoIdname.toUpperCase()) !== -1) {
                            result.push(str)
                        }
                    }
                    let length = result.length > 10 ? 10 : result.length
                    for (let i = 0; i < length; i++) {
                        this.data3.push(result[i])
                    }
                }
            },

            //车辆所有人模糊查询
            changedata4(e) {
                console.log(e)
                this.data4 = []
                //获取车辆所有人列表
                store.dispatch('VehicleOwnerInfoServ_SearchByName', {
                    params: {
                        name: this.vehicleOwnerInfoIdname
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.list2 = res.data
                    // this.list4 = []
                    for (let i = 0; i < res.data.length; i++) {
                        this.list4.push(res.data[i])
                        this.data4.push(res.data[i].name)
                    }
                })
                    .catch((err) => {
                        console.log(err)
                    })


                // this.change2()

            },
            change2() {
                // eslint-disable-next-line eqeqeq
                this.data4 = []
                if (!this.vehicleOwnerInfoIdname || this.vehicleOwnerInfoIdname === '') {
                    // this.data3.splice(0)
                } else {
                    // this.data3.splice(0)

                    let result = []
                    for (let i = 0; i < this.list2.length; i++) {
                        let str = this.list2[i].name
                        if (str.toUpperCase().indexOf(this.vehicleOwnerInfoIdname.toUpperCase()) !== -1) {
                            result.push(str)
                        }
                    }
                    let length = result.length > 10 ? 10 : result.length
                    for (let i = 0; i < length; i++) {
                        this.data4.push(result[i])
                    }
                }
            },

            //预绑定车辆分组模糊查询
            changedata5(e) {
                console.log(e)
                this.data5 = []
                //获取车辆所有人列表
                store.dispatch('VehicleInfoGroupServ_SearchByName', {
                    params: {
                        name: this.vehicleInfoGroup
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    for (let i = 0; i < res.data.length; i++) {
                        this.list5.push(res.data[i])
                        this.data5.push(res.data[i].name)
                    }
                })
                    .catch((err) => {
                        console.log(err)
                    })


                // this.change2()

            },
            //预绑定车辆分组模糊查询
            changedata6(e) {
                console.log(e)
                this.data6 = []
                //获取车辆所有人列表
                store.dispatch('SalesChannelServ_SearchByName', {
                    params: {
                        name: this.salesChannel
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    for (let i = 0; i < res.data.length; i++) {
                        this.list6.push(res.data[i])
                        this.data6.push(res.data[i].name)
                    }
                })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            filterMethod(value, option) {
                // console.log(option)
                // return option.toUpperCase().indexOf(value.toUpperCase()) !== -1
                return true
            },


            addclientInfoId() {
                this.modal2 = true
            },
            //增加客户信息
            ok2() {
                store.dispatch('ClientInfoServ_AddObj', {
                    params: {
                        name: this.name,
                        phoneNum: this.phoneNum,
                        address: this.address,//非必填
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.list3 = []
                    //获取客户列表
                    store.dispatch('ClientInfoServ_GetAll'

                        , {
                            params: null,
                            urlparams: null
                        }).then((res) => {
                        console.log(res)
                        this.list = res.data
                        // this.list3 = []
                        for (let i = 0; i < res.data.length; i++) {
                            this.list3.push(res.data[i])
                        }
                    })
                        .catch((err) => {
                            console.log(err)
                        })
                })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            //取消增加客户信息
            cancel2() {
            },

            addvehicleOwnerInfoId() {
                this.modal3 = true
            },
            //增加客户信息
            ok3() {
                store.dispatch('VehicleOwnerInfoServ_AddObj', {
                    params: {
                        name: this.vehicleOwnerInfoname,
                        phoneNum: this.vehicleOwnerInfophoneNum,
                        address: this.vehicleOwnerInfoaddress,//非必填
                        remark: this.vehicleOwnerInforemark,//非必填
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.list4 = []
                    //获取车辆所有人列表
                    store.dispatch('VehicleOwnerInfoServ_GetAll', {
                        params: null,
                        urlparams: null
                    }).then((res) => {
                        console.log(res)
                        this.list2 = res.data
                        // this.list4 = []
                        for (let i = 0; i < res.data.length; i++) {
                            this.list4.push(res.data[i])
                        }
                    })
                        .catch((err) => {
                            console.log(err)
                        })
                })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            //取消增加客户信息
            cancel3() {
            },
            //确认创建订单
            ok() {

                for (let i = 0; i < this.list3.length; i++) {
                    if (this.clientInfoIdname === this.list3[i].name) {
                        this.clientInfoId = this.list3[i].id
                    }
                }
                // console.log(this.list3)
                // console.log(this.clientInfoId)

                for (let i = 0; i < this.list4.length; i++) {
                    if (this.vehicleOwnerInfoIdname === this.list4[i].name) {
                        this.vehicleOwnerInfoId = this.list4[i].id
                    }
                }
                // console.log(this.list4)
                // console.log(this.vehicleOwnerInfoId)
                //
                // console.log(this.attention)
                for (let i = 0; i < this.list5.length; i++) {
                    if (this.vehicleInfoGroup === this.list5[i].name) {
                        this.vehicleInfoGroupId = this.list5[i].id
                    }
                }
                // console.log(this.vehicleInfoGroupId)
                for (let i = 0; i < this.list6.length; i++) {
                    if (this.salesChannel === this.list6[i].name) {
                        this.salesChannelId = this.list6[i].id
                    }
                }

                if (this.money == '' || this.money == null) {
                    alert('请输入金额')
                } else if (this.overtime == '') {
                    alert('请选择日期')
                } else if (this.businessType !== 1 && this.businessType !== 2) {
                    alert('请选择业务类型')
                } else if (this.qghyptOption !== 0 && this.qghyptOption !== 1 && this.qghyptOption !== 2) {
                    alert('请选择货运平台')
                } else if (this.billType !== 1 && this.billType !== 2 && this.billType !== 3) {
                    alert('请选择开票类型')
                } else if (this.clientInfoId == '') {
                    alert('请填写客户信息')
                } else if (this.registrationNum == null && this.vin == null) {
                    alert('请填写车牌号或车架号')
                } else if (this.registrationNum !== null && this.registrationColor !== 1 && this.registrationColor !== 2 && this.registrationColor !== 3 && this.registrationColor !== 4) {
                    alert('请选择车牌颜色')
                // } else if (this.vehicleOwnerInfoId == '') {
                //     alert('请填写车辆所有人信息')
                } else {
                    this.disabled = true
                    console.log('money' + this.money)
                    console.log('overtime' + this.overtime)
                    console.log('businessType' + this.businessType)
                    console.log('qghyptOption' + this.qghyptOption)
                    console.log('billType' + this.billType)
                    console.log('clientInfoId' + this.clientInfoId)
                    console.log('registrationNum' + this.registrationNum)
                    console.log('vin' + this.vin)
                    console.log('registrationColor' + this.registrationColor)
                    console.log('vehicleOwnerInfoId' + this.vehicleOwnerInfoId)
                    console.log('vehicleInfoGroupId' + this.vehicleInfoGroupId)
                    console.log('salesChannelId' + this.salesChannelId)


                    //增加安装订单
                    store.dispatch('InstallOrderServ_AddObj', {
                        params: {
                            totalAmount: this.money,//应收总金额
                            serviceDatetime: this.overtime,//服务到期时间
                            businessUserId: this.salesmanID,//跟进业务员id
                            businessType: this.businessType,//业务类型

                            multiDevices: this.attention,//多设备,暂不选择，默认为false
                            qghyptOption: this.qghyptOption,//上传货运平台选项
                            billType: this.billType,//开票类型
                            remark: this.remark,//备注
                            clientInfoId: this.clientInfoId,//客户信息
                            vehicleInfoGroupId: this.vehicleInfoGroupId,//预绑定车辆分组id
                            tempVehicleInfo: {//车辆信息
                                registrationNum: this.registrationNum,//车牌号
                                registrationColor: this.registrationColor,//车牌颜色
                                vin: this.vin,//车架号
                                vehicleOwnerInfoId: this.vehicleOwnerInfoId,//车辆所有人信息
                                attention: this.attention,//是否重点关注车辆
                                engineNum: this.engineNum,//发动机号
                            },
                                salesChannelId:this.salesChannelId
                        },
                        urlparams: null
                    }).then((res) => {
                        console.log(res)
                        Toast('创建订单成功');
                        this.$router.push({
                            name: 'resalesman'
                        })
                    }).catch((err) => {
                        console.log(err)
                        this.disabled = false
                        Toast(err + '创建订单失败');
                        // this.$Message.error(err)
                    })
                }
            },
            cancel() {
            },

        },
        watch: {
            // 车架号的正则判断
            vin: function () {
                this.vin = this.vin.replace(/[\W]/g, '');
            },
        },
        computed: {
            installlistcpu() {
                return this.installlist
            }
        },
        mounted() {
            this.$nextTick(() => {

                // //获取客户列表
                // store.dispatch('ClientInfoServ_GetAll'
                //
                //     , {
                //         params: null,
                //         urlparams: null
                //     }).then((res) => {
                //     console.log(res)
                //     this.list = res.data
                //     // this.list3 = []
                //     for (let i = 0; i < res.data.length; i++) {
                //         this.list3.push(res.data[i])
                //     }
                // })
                //     .catch((err) => {
                //         console.log(err)
                //     })
                // //获取车辆所有人列表
                // store.dispatch('VehicleOwnerInfoServ_GetAll', {
                //     params: null,
                //     urlparams: null
                // }).then((res) => {
                //     console.log(res)
                //     this.list2 = res.data
                //     // this.list4 = []
                //     for (let i = 0; i < res.data.length; i++) {
                //         this.list4.push(res.data[i])
                //     }
                // })
                //     .catch((err) => {
                //         console.log(err)
                //     })

                //获取个人账号信息，默认业务员id，姓名
                store.dispatch('AccountServ_GetSelfInfo', {
                    params: null,
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    // 实名:res.data.realName
                    this.salesmanID = res.data.id
                    this.salesmanname = res.data.realName
                })
                    .catch((err) => {
                        console.log(err)
                    })
            })
        }
    }
</script>

<style>


    /*右侧内容*/
    .content {
        /*background-color: red;*/
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 15px 0 10px;
    }

    .content .name {
        font-size: 17px;
        color: #333;
        overflow: hidden;
        font-weight: bold;
        overflow: hidden;
    }

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }

    .next .next1 .next2 {
        flex: 1;
        margin-top: 0px;
        color: #666;
        font-size: 12px;
    }

    ._button {
        text-align: center;
    }

</style>

